import Typography from "components/Typography"
import React from "react"
import Box from "components/Box"
import { StyledHeader } from "./styles"
import LanguageSelector from "components/LanguageSelector/LanguageSelector"
import { getPlanetId } from "layouts"
import { Link } from "gatsby"
import { getLangFromPath } from "utils"

const Header: React.FC = (): JSX.Element => {
  const planedSelected = getPlanetId()
  const lang = getLangFromPath()
  return (
    <StyledHeader>
      <Link to={`/${lang}`}>
        <Box>
          <Typography
            variant="menuTitle"
            color="text.secondary"
            fontSize={12}
            letterSpacing={6.5}
            lineHeight={1}
            px={1}
            textAlign="center"
          >
            STANISŁAW
          </Typography>
          <Typography
            variant="menuTitle"
            color="text.secondary"
            lineHeight={1}
            fontSize={56}
            textAlign="center"
            pl={2}
          >
            LEM
          </Typography>
        </Box>
      </Link>
      <LanguageSelector planetSelected={planedSelected} />
    </StyledHeader>
  )
}

export default Header
